
    <div
        class="crypttp-container-fixed-width"
        [style.max-width]="buttonWidth"
    >
        <button
            class="embed-one-click-crypttp-button"
            (click)="proceedCheckout()"
            [style.background]="finalButtonColor"
            [style.color]="fontColor"
        >
            <img class="crypttp-logo-image-placeholder" src="{{image}}"/>
            {{finalButtonText}}
        </button>

        <div [style.display]="display_loader" class="crypttp-loader">
            <svg viewBox="0 0 80 80">
                <circle name="crypttp-loader" cx="40" cy="40" r="32"></circle>
            </svg>
        </div>
    </div>
    